import type { FormEvent } from "react";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import type { BreadcrumbItem } from "@/hooks/useSeo";

interface TopicsHeroProps {
  keyword: string;
  onKeywordChange: (value: string) => void;
  onSearch: () => void;
  total: number;
  crumbs: BreadcrumbItem[];
}

export default function TopicsHero({
  keyword,
  onKeywordChange,
  onSearch,
  total,
  crumbs,
}: TopicsHeroProps) {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch();
  };

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="px-4 py-8 md:px-8 md:py-12">
        <Breadcrumbs items={crumbs} />
        <div className="mt-5 grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
          <div>
            <h1 className="font-heading text-2xl font-black leading-tight text-foreground-950 md:text-[36px]">
              话题档案 · 全部事件进展
            </h1>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              这里收录站内全部事件记录，共 {total} 份档案。每份档案都包含事件综述、关键节点与完整时间线，并标注当前所处的进展状态。
            </p>
          </div>
          <form
            onSubmit={handleSubmit}
            role="search"
            className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 focus-within:border-primary-400"
          >
            <i className="ri-search-line text-base text-foreground-500" aria-hidden="true" />
            <input
              type="search"
              value={keyword}
              onChange={(event) => onKeywordChange(event.target.value)}
              placeholder="输入事件名称或标签，例如「剪辑争议」"
              aria-label="搜索事件名称或标签"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
            />
            <button
              type="submit"
              className="shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              搜索
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}